<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Tambah Tarif</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Login Via</label>
                                        <select class="form-control" placeholder="Login Via..."  v-model="tambah.data.via">
                                            <option value="Pilih Via" selected Disabled>Pilih Via</option>
                                            <option value="ip">IP Public</option>
                                            <option value="tunnel">Tunnel</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">IP</label>
                                        <input type="text" class="form-control" placeholder="IP / Tunnel..." v-model="tambah.data.ip">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Username</label>
                                        <input type="text" class="form-control" placeholder="Username..." v-model="tambah.data.username">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Password</label>
                                        <input type="password" class="form-control" placeholder="Password..." v-model="tambah.data.password">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Konf. Password</label>
                                        <input type="password" class="form-control" placeholder="Konfirmasi Password..." v-model="tambah.data.cpassword">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama Mikrotik</label>
                                        <input type="text" class="form-control" placeholder="Tarif Paket..." v-model="tambah.data.nama">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                            <div class="form-group">
                                <button class="btn btn-primary" @click="tambah.submit()">Simpan</button>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-warning" role="alert" v-show="data.alert">
                                    {{data.alertText}}
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
        alert: false,
        alertText: ''
    })

	const tambah = {
      	data: reactive({
            via: "Pilih Via",
            id: null,
            ip: '',
            username: '',
            password: '',
            cpassword: '',
            nama: ''
      	}),
		submit() {
            var datax = this.data;

            if (datax.via == "Pilih Via") {
                data.alert = true;
                data.alertText = "Anda belum memilih Login Via";
                return false;
            }
            if (datax.ip == "") {
                data.alert = true;
                data.alertText = "IP / Tunnel Tidak boleh kosong";
                return false;
            }
            if (datax.nama == "") {
                data.alert = true;
                data.alertText = "Nama Tidak boleh kosong";
                return false;
            }
            if (datax.username == "") {
                data.alert = true;
                data.alertText = "Username Tidak boleh kosong";
                return false;
            }
            if (datax.password == "") {
                data.alert = true;
                data.alertText = "Password Tidak boleh kosong";
                return false;
            }
            if (datax.cpassword == "") {
                data.alert = true;
                data.alertText = "Konfirmasi Password Tidak boleh kosong";
                return false;
            }
            if (datax.password != datax.cpassword) {
                data.alert = true;
                data.alertText = "Password Tidak Sama";
                return false;
            }

			var datac = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
                id: datax.id,
                ip: datax.ip,
                nama: datax.nama,
                username: datax.username,
                password: datax.cpassword,
                via: datax.via
        	};

            data.alert = false;
				
			var apiUrl = inter.MiktorikSimpan();
			myGlobal.call(datac,apiUrl).then(x => {
				if (x.status == true) {
                    location.href="#/mikrotik"
				} else {
					//alert(x.pesan);
				}
			})
		}
    }
    return {
      data, 
      tambah
    }

  },
  mounted () {

    var param = this.$route.params;
    if (param.id != null) {
        document.title = "Edit Mikrotik";
        this.tambah.data.via = param.via;
        this.tambah.data.ip = param.ip;
        this.tambah.data.id = param.id;
        this.tambah.data.username = param.username;
        this.tambah.data.nama = param.nama;
    } else {
        document.title = "Tambah Mikrotik";
    }
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mikrotik/tambah.vue